import { appEnvironment } from 'environments/environment';

export const DEVTOOLS_STORAGE_KEY = 'store-devtools-enabled';

const DEVTOOLS_STORAGE_FULL_KEY = `interacta2:${DEVTOOLS_STORAGE_KEY}`;

export function isStoreDevtoolsEnabled(): boolean {
    if (appEnvironment.production) return false;
    try {
        return (
            JSON.parse(
                localStorage.getItem(DEVTOOLS_STORAGE_FULL_KEY) ?? 'false',
            ) === true
        );
    } catch {
        return false;
    }
}
